/*jshint esversion: 11 */
import Vue from 'vue';
import Router from 'vue-router';
//import store from './store';
//import Dashboard from './views/Dashboard.vue'
//import Projects from './views/Projects.vue'
//import Team from './views/Team.vue'
//import LogIn from './views/LogIn.vue'
//import Downloads from './views/Downloads.vue'
//import BI from './views/BI.vue'
import IAM from "./views/Iam.vue";
import IamPolicies from "./components/IamPolicies.vue";
import IamGroups from "./components/IamGroups.vue";
import IamIdentities from "./components/IamIdentities.vue";
import IamSettings from "./components/IamSettings.vue";
import IamImpersonation from "./components/IamImpersonation.vue";
import IamPreferences from "./components/IamPreferences.vue";

import ContactService from "./views/ContactService.vue";
// import CsConfig from "./components/CsConfig.vue";
import CsWorkflowDesigner from "./components/CsWorkflowDesigner.vue";
import CsImport from "./components/CsImports.vue";
import CsExport from "./components/CsExports.vue";
import CsIndex from "./components/CsIndexes.vue";
import CsDashboards from "./components/CsDashboards.vue";
import CsDocuments from "./components/CsDocuments.vue";
import CsDeletes from "./components/CsDeletes.vue";
import CsRemoteAccesses from "./components/CsRemoteAccesses.vue";
import CsSettings from "./components/CsSettings.vue";
import CsActions from "./components/CsActions.vue";
import CsActionsV2 from "./components/CsActionsV2.vue";
import CsTriggers from "./components/CsTriggers";
import CsTriggersV2 from "./components/CsTriggersV2.vue";
import CsTags from "./components/CsTags.vue";
import CsMailTracking from "./components/CsMailTracking.vue";
import CsCsvProcessor from "./components/CsCsvProcessor.vue";

import LakeService from "./views/LakeService.vue";
import LsDashboards from "./components/LsDashboards.vue";
import LsExports from "./components/LsExports.vue";
import LsFolderStructure from "./components/LsFolderStructure.vue";
import LsQuery from "./components/LsQuery.vue";
import LsAiAssistant from "./components/LsAiAssistant.vue";
import LsSettings from "./components/LsSettings.vue";

import AdminService from "./views/AdminService.vue";
import AsImports from "./components/AsImports.vue";
import AsExports from "./components/AsExports.vue";
import AsDeletes from "./components/AsDeletes.vue";
import AsSchedules from "./components/AsSchedules.vue";
import AsRDLs from "./components/AsRDLs.vue";
import AsDDLs from "./components/AsDDLs.vue";
import AsDownloads from "./components/AsDownloads.vue";
import AsAccounts from "./components/AsAccounts.vue";
import AsRemoteAccesses from "./components/AsRemoteAccesses.vue";
import AsRDLsForCS from "./components/AsRDLsForCS.vue";
import AsDDLsForCS from "./components/AsDDLsForCS.vue";
import AsSettings from "./components/AsSettings.vue";
import AsApiCalls from "./components/AsApiCalls.vue";
import AsIamAccounts from "./components/AsIamAccounts.vue";
import AsExportActions from "./components/AsExportActions.vue";
import AsTriggerActions from "./components/AsTriggerActions.vue";

import QuickSight from "./components/QuickSight.vue";

Vue.use(Router);

function lazyLoad(view){
   return() => import(`@/views/${view}.vue`);
}

//console.log('user: ', store.getters.user);

export default new Router({
   mode: 'history',
   base: process.env.BASE_URL,
   routes: [
      {
         path: '/home',
         name: 'home',
         component: lazyLoad('KCHomePage')
      },
      {
         path: '/dashboards',
         name: 'dashboards',
         component: lazyLoad('Dashboard')
      },
      {
         path: '/csv-processor',
         name: 'csv-processor',
         component: lazyLoad('KCCSVProcessorView')
      },
      // {
      //   path: '/bi',
      //   name: 'bi',
      //   component: lazyLoad('BI')
      // },
      {
         path: '/projects',
         name: 'projects',
         component: lazyLoad('Projects')
      },
      {
         path: '/team',
         name: 'team',
         component: lazyLoad('Team')
      },
      {
         path: '/',
         name: 'login',
         component: lazyLoad('LogIn')
      },
      {
         path: '/downloads',
         name: 'downloads',
         component: lazyLoad('Downloads')
      },
      {
         path: '/module/:id',
         name: 'module',
         component: lazyLoad('IFrame'),
         props: true
      },
      {
         path: '/iam',
         component: IAM,
         name: 'iam',
         children: [
            {
               path: '',
               name: 'iamHome',
               component: IamPolicies
            },
            {
               path: 'policies',
               name: 'Policies',
               component: IamPolicies
            },
            {
               path: 'groups',
               name: 'Groups',
               component: IamGroups
            },
            {
               // UserPosts will be rendered inside User's <router-view> when /user/:id/posts is matched
               path: 'identities',
               name: 'identities',
               component: IamIdentities
            },
            {
               path: 'impersonation',
               name: 'impersonation',
               component: IamImpersonation
            },
            {
               path: 'settings',
               name: 'settings',
               component: IamSettings
            },
            {
               path: 'preferences',
               name: 'preferences',
               component: IamPreferences
            }
         ]
      },
      {
         path: '/contact-service',
         component: ContactService,
         children: [
            {
               path: '',
               //name: 'csHome',
               //component: CsImport
               redirect: 'imports'
            },
            //  {
            //     path: 'config',
            //     name: 'csConfig',
            //     component: CsConfig
            //  },
            {
               path: 'workflow-designer',
               name: 'CsWorkflowDesigner',
               component: CsWorkflowDesigner
            },
            {
               path: 'imports',
               name: 'csImport',
               component: CsImport
            },
            {
               path: 'actions',
               name: 'csActions',
               component: CsActions
            },
            {
               path: 'actions-v2',
               name: 'csActionsV2',
               component: CsActionsV2
            },
            {
               path: 'triggers',
               name: 'csTriggers',
               component: CsTriggers
            },
            {
               path: 'triggers-v2',
               name: 'csTriggersV2',
               component: CsTriggersV2
            },
            {
               path: 'exports',
               name: 'csExport',
               component: CsExport
            },
            {
               path: 'tags',
               name: 'csTags',
               component: CsTags
            },
            {
               path: 'indexes',
               name: 'CsIndex',
               component: CsIndex
            },
            {
               path: 'dashboards',
               name: 'CsDashboards',
               component: CsDashboards
            },
            {
               path: 'documents',
               name: 'csDocuments',
               component: CsDocuments
            },
            {
               path: 'deletes',
               name: 'csDeletes',
               component: CsDeletes
            },
            {
               path: 'access',
               name: 'CsRemoteAccesses',
               component: CsRemoteAccesses
            },
            {
               path: 'settings',
               name: 'CsSettings',
               component: CsSettings
            },
            {
               path: 'mail-tracking',
               name: 'csMailTracking',
               component: CsMailTracking
            },
            {
               path: 'csv-processor',
               name: 'csCsvProcessor',
               component: CsCsvProcessor
            }
         ]
      },
      {
         path: '/lake-service',
         component: LakeService,
         children: [
            {
               path: '',
               name: 'lsHome',
               component: LsDashboards
            },
            {
               path: 'dashboards',
               name: 'lsDashboards',
               component: LsDashboards
            },
            {
               path: 'exports',
               name: 'lsExports',
               component: LsExports
            },
            {
               path: 'folders',
               name: 'lsFolderStructure',
               component: LsFolderStructure
            },
            {
               path: 'query',
               name: 'lsQuery',
               component: LsQuery
            },
            {
               path: 'ai-assistant',
               name: 'aiAssistant',
               component: LsAiAssistant
            },
            {
               path: 'settings',
               name: 'settings',
               component: LsSettings
            }
         ]
      },
      {
         path: '/admin-service',
         component: AdminService,
         children: [
            {
               path: '',
               name: 'asHome',
               component: AsImports
            },
            {
               path: 'imports',
               name: 'asImports',
               component: AsImports
            },
            {
               path: 'exports',
               name: 'asExports',
               component: AsExports
            },
            {
               path: 'deletes',
               name: 'asDeletes',
               component: AsDeletes
            },
            {
               path: 'schedules',
               name: 'asSchedules',
               component: AsSchedules
            },
            {
               path: 'rdls',
               name: 'asRDLs',
               component: AsRDLs
            },
            {
               path: 'ddls',
               name: 'asDDLs',
               component: AsDDLs
            },
            {
               path: 'downloads',
               name: 'asDownloads',
               component: AsDownloads
            },
            {
               path: 'accounts',
               name: 'asAccounts',
               component: AsAccounts
            },
            {
               path: 'remote-accesses',
               name: 'asRemoteAccesses',
               component: AsRemoteAccesses
            },
            {
               path: 'cs-ddls',
               name: 'asDDLsForCS',
               component: AsDDLsForCS
            },
            {
               path: 'cs-rdls',
               name: 'ssRDLsForCS',
               component: AsRDLsForCS
            },
            {
               path: 'settings',
               name: 'asSettings',
               component: AsSettings
            },
            {
               path: 'api-calls',
               name: 'asApiCalls',
               component: AsApiCalls
            },
            {
               path: 'iam-accounts',
               name: 'asIamAccounts',
               component: AsIamAccounts
            },
            {
               path: 'export-actions',
               name: 'asExportActions',
               component: AsExportActions
            },
            {
               path: 'trigger-actions',
               name: 'asTriggerActions',
               component: AsTriggerActions
            }
         ]
      },
      {
         path: '/quick-sight',
         component: QuickSight
      }
   ]
});
